import json from './sprite.js';

export default {
    handle: 'ENG_SPS5-FreeTime',
    label: 'en_SPS5-FreeTime_225002257',
    json,
};
